import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minWidth: 'max-content',
      padding: theme.spacing(0.625, 1.25, 0.5),
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.pxToRem(14),
      color: COLORS.gray.black,
      borderRadius: theme.shape.borderRadiusSmall,
    },
  }),
  { name: 'GenerationToolTag' }
);
